import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  vglNewsLetterForm: {
    padding: "30px 20px",
    backgroundColor: "#fdd3c2 !important",
    boxShadow: "none !important",
    maxWidth: 700,
    margin: "0 auto",
    marginBottom: "50px !important",
  },
  vglSubscriptionForm: {
    display: "flex",
    flexDirection: "row",
    boxSizing: "border-box",
    width: "100%",
    borderRadius: 2,
    borderStyle: "none",
    borderWidth: 0,
    borderColor: "rgb(0, 0, 0)",
    backgroundColor: "rgba(255, 255, 255, 0)",
    backgroundRepeat: "no-repeat",
    backgroundPositionY: "50%",
    padding: 0,
  },
  vglFormHeading: {
    fontSize: 14,
    wordBreak: "break-word",
    color: "#000",
    marginBottom: 0,
    "& strong": {
      fontSize: 24,
    },
    "& span": {
      fontSize: 12,
    },
  },
  vglFormInput: {
    boxSizing: "border-box",
    padding: "0px 0px 0px 16px",
    height: 38,
    textAlign: "left",
    color: "rgb(0, 0, 0)",
    fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: 0,
    background: "transparent !important",
    border: "1px solid #000 !important",
    borderRadius: "0px !important",
    boxShadow: "none !important",
    outline: "none",
    margin: "10px 0",
  },
  vglFormButtonSubmit: {
    position: "relative",
    width: "100%",
    background: "rgb(0, 0, 0)",
    borderRadius: 0,
    borderStyle: "none",
    borderColor: "rgb(0, 0, 0)",
    borderWidth: 0,
    color: "rgb(255, 255, 255)",
    fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
    fontSize: 14,
    fontWeight: 200,
    letterSpacing: 0,
    lineHeight: 1,
    whiteSpace: "normal",
    paddingTop: 11,
    paddingBottom: 11,
    textAlign: "center",
    wordBreak: "break-word",
    alignSelf: "flex-end",
    cursor: "pointer",
    border: "none",
    textTransform: "uppercase",
    outline: "none",
    "&:focus": {
      outline: "none !important",
    },
  },
}));
